import notification from 'ant-design-vue/es/notification'


const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '系统异常，请联系管理员',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};

const info = (response, text) => {
    if (response) {
        if (response.status == 403) {
            return false;
        }
        if (response.status >= 200 && response.status < 300) {
            notification.success({
                message: `成功`,
                description: text,
            });
            return true;
        } else if (response.status === 500) {
            const textObj = JSON.parse(response.text);
            notification.error({
                message: `错误`,
                description: textObj.exception || textObj.message || codeMessage[response.status],
            });
            return false;
        }
        else if (response instanceof Error) {
            const textObj = JSON.parse(response.text);
            notification.error({
                message: `错误`,
                description: textObj.exception || codeMessage[response.status],
            });
            return false;
        } else {
            notification.error({
                message: `错误`,
                description: codeMessage[response.status],
            });
            return false;
        }
    }
    notification.error({
        message: `错误`,
        description: '请求异常，请联系管理员',
    });
    return false;
};

export default info;



// WEBPACK FOOTER //
// ./src/utils/hint.js